import React from 'react'
import injectSheet from 'react-jss'
import styles from './teacher.styles'
import { PobbleAvatar } from 'pobble-components/dist/pobble-avatar'
import { Cell } from 'pobble-components/dist/table'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'
import TrashIcon from 'react-icons/lib/fa/trash'
import EmailIcon from 'react-icons/lib/fa/envelope-o'
import Button from 'pobble-components/dist/button'
import Tooltip from 'pobble-components/dist/tooltip'

const Teacher = ({
  classes,
  id,
  schoolId,
  userId,
  name,
  avatar,
  email,
  schoolLeader,
  lastSignIn,
  inactive,
  isCurrentUser,
  confirmed,
  onPromote,
  onDemote,
  onRemove,
  onResendInvitation,
  canGetAGroupSub,
  groupSubId,
  onAddGroupSub,
  onRemoveGroupSub,
  assignedGroupSubId,
  assignedGroupSub,
  addonId,
  nbOfGroupSubs,
  availableGroupSubId,
  canSeeGroupSeatsOptions
}) => {
  return (
    <tr>
      <Cell>
        <div className={classes.teacher}>
          <PobbleAvatar
            avatar={avatar}
            name={name}
            className={classes.avatar}
          />
          <span className={classes.name}>{name}</span>
          {isCurrentUser && <span className={classes.label}>You</span>}
          {/*schoolLeader && <span className={classes.label}>Admin</span>*/}
        </div>
      </Cell>
      <Cell>{email}</Cell>
      <Cell className={inactive ? classes.inactive : ''}>
        {confirmed ? (
          lastSignIn
        ) : (
          <span className={classes.pending}>Pending</span>
        )}
      </Cell>

      {canSeeGroupSeatsOptions && (
        <Cell>
          {!assignedGroupSubId && (
            <div className={classes.subLabel}>No active T&L subscription</div>
          )}

          {assignedGroupSubId && (
            <div className={classes.subLabel}>
              {`${assignedGroupSub.plan_marketing_name.replace(
                ' annual addon1',
                ''
              )}`}
            </div>
          )}

          {!!nbOfGroupSubs &&
            canGetAGroupSub &&
            !assignedGroupSubId && (
              <Button
                simple
                action={() => onAddGroupSub(availableGroupSubId, id)}
                className={classes.simpleButton}>
                Assign one
              </Button>
            )}

          {assignedGroupSubId && (
            <Button
              simple
              className={classes.simpleButton}
              action={() => onRemoveGroupSub(assignedGroupSubId, addonId)}>
              Remove
            </Button>
          )}
        </Cell>
      )}

      <Cell>
        {!confirmed && (
          <Button
            tall
            primary
            icon={<EmailIcon />}
            action={() => onResendInvitation(id)}>
            Resend invitation
          </Button>
        )}
        {confirmed &&
          schoolLeader && (
            <div className={classes.hoveredAction}>
              <span className={classes.label}>School administrator</span>
              <Button simple action={() => onDemote(id)}>
                Unassign admin
              </Button>
            </div>
          )}
        {confirmed &&
          !schoolLeader && (
            <div className={classes.hoveredAction}>
              <Tooltip
                content={
                  'An admin can edit the school information, add teachers and synchronise pupils data via an MIS'
                }>
                <Button simple action={() => onPromote(id)}>
                  Assign as admin
                </Button>
              </Tooltip>
            </div>
          )}
      </Cell>
      <Cell className={classes.actions}>
        <Tooltip content={schoolLeader ? 'Unassign as admin first' : ''}>
          <Button
            tall
            secondary
            disabled={schoolLeader || isCurrentUser}
            icon={<TrashIcon />}
            action={() => {
              openConfirmationDialog({
                bodyText: `Are you sure you want to remove this teacher ?`,
                confirmText: 'Remove teacher',
                action: () =>
                  onRemove(schoolId, id, assignedGroupSubId, addonId)
              })
            }}>
            Remove
          </Button>
        </Tooltip>
        {/*<DropMenu
          popoverClassName={classes.contextMenuHolder}
          button={({ ref, togglePopover }) => (
            <MoreButton forwardedRef={ref} onClick={togglePopover} />
          )}>
          {({ Menu, MenuItem, IconHolder, Separator, closePopover }) => (
            <Menu>
              {schoolLeader && (
                <MenuItem onClick={() => closePopover() && onDemote(id)}>
                  <IconHolder>
                    <DownIcon />
                  </IconHolder>
                  Unassign as school leader / admin
                </MenuItem>
              )}
              {!schoolLeader && (
                <MenuItem onClick={() => closePopover() && onPromote(id)}>
                  <IconHolder>
                    <UpIcon />
                  </IconHolder>
                  Assign as school leader / admin
                </MenuItem>
              )}
              {!isCurrentUser && !schoolLeader && <Separator />}
              {!isCurrentUser && !schoolLeader && (
                <MenuItem
                  onClick={() => {
                    closePopover()
                    openConfirmationDialog({
                      bodyText: `Are you sure you want to remove this teacher ?`,
                      confirmText: 'Remove teacher',
                      action: () => onRemove(schoolId, id)
                    })
                  }}>
                  <IconHolder>
                    <CloseIcon />
                  </IconHolder>
                  Remove from school
                </MenuItem>
              )}
              {!confirmed && (
                <MenuItem
                  onClick={() => closePopover() && onResendInvitation(id)}>
                  <IconHolder>
                    <EmailIcon />
                  </IconHolder>
                  Resend invitation
                </MenuItem>
              )}
            </Menu>
          )}
        </DropMenu>*/}
      </Cell>
    </tr>
  )
}

export default injectSheet(styles)(Teacher)
